import Vue from 'vue';
import './directives/dynamic-placeholder';
import './plugins/gtm/';
import './plugins/touch-events/';
import './plugins/base-components-autoloader';
import './plugins/toggle-button/';
import './plugins/async-computed';
import './plugins/vue-reset';
import './plugins/vue-infinite-loading';
import './plugins/vue-final-modal';
import './plugins/vue-toasted';
import './plugins/vue2-storage';
import './plugins/v-hotkey';
import './plugins/composition-renderer';

Vue.config.productionTip = false;

import pinia from './plugins/pinia';
import store from './store';
import i18n from './plugins/i18n';
import getRouter from './router/factory';

import 'swiper/css/swiper.css';

const createApp = (App, routes) => {
  const router = getRouter(routes);

  // Abstract routing requires initial routing to be set
  // Ref: https://github.com/vuejs/vue-router/issues/729
  const hash = window.location.hash.replace('#', '');
  router.replace(hash);

  return new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    pinia
  });
};

export default createApp;
